var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parameter-font-size"},[_c('number-input-select',{staticClass:"parameter-font-size__input-area",attrs:{"input-value":_vm.fontSize.number,"select-value":_vm.fontSize.suffix,"select-items":['px', '%', 'rem', 'em']},on:{"change":_vm.onNumberInput,"select-change":_vm.onSuffixChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }